module.exports = __webpack_public_path__ + "img/Jessica_Eisenhauer.7c99ad61.png";